<form>
  <spk-card title="Search Application Settings">
    <spk-search-grid #grid defaultSortProperty="Name ASC" list="ApplicationSettingSearchRow" [leftLinks]="leftLinks"></spk-search-grid>
  </spk-card>
</form>